import { lazy } from "react";

const ImageListPage = lazy(() => import("./main"));
const CreateImagepage = lazy(() => import("./create"));
const UpdateImagePage = lazy(() => import("./update"));

export { ImageListPage, CreateImagepage, UpdateImagePage };
